module.exports = __webpack_public_path__ + "static/media/298289.731fdc00.png";